module.exports = __webpack_public_path__ + "static/media/indicationLike.33455efd.svg";